import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=047d6712&scoped=true&"
import script from "./messages.vue?vue&type=script&lang=ts&"
export * from "./messages.vue?vue&type=script&lang=ts&"
import style0 from "./messages.vue?vue&type=style&index=0&id=047d6712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d6712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047d6712')) {
      api.createRecord('047d6712', component.options)
    } else {
      api.reload('047d6712', component.options)
    }
    module.hot.accept("./messages.vue?vue&type=template&id=047d6712&scoped=true&", function () {
      api.rerender('047d6712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_recipient/messages.vue"
export default component.exports